// src/i18n/en/lockers.js
const lockers = {
    name: 'Locker |||| Lockers',
    title: 'Locker Management',
    titles: {
        list: 'Lockers',
        create: 'New Locker',
        edit: 'Edit Locker',
        show: 'Locker Details',
    },
    fields: {
        id: 'ID',
        displayNumber: 'N.',
        display_number: 'N.',
        hardwareId: 'ID',
        hardware_id: 'ID',
        lockerController: 'Controller',
        hotel: 'Hotel',
        hotelId: 'Hotel',
        hotel_id: 'Hotel',
        zone: 'Zone',
        zoneId: 'Zone',
        zone_id: 'Zone',
        lockerType: 'Type',
        locker_type: 'Locker Type',
        lockerTypeId: 'Type',
        status: 'Status',
        statusReason: 'Status Reason',
        status_reason: 'Status Reason',
        assignment: 'Assignment',
        assignmentId: 'Assignment',
        assignment_id: 'Assignment ID',
        assignedAt: 'Assigned on',
        assigned_at: 'Assignment Date',
        lastMaintenance: 'Last maintenance',
        last_maintenance_at: 'Last Maintenance',
        notes: 'Notes',
        blockReason: 'Block Reason',
        isActive: 'Active',
        createdAt: 'Created',
        updatedAt: 'Updated',
    },
    status: {
        available: 'Available',
        occupied: 'Occupied',
        maintenance: 'Maintenance',
        outOfService: 'Out of service',
        out_of_service: 'Out of Service',
        reserved: 'Reserved',
        blocked: 'Blocked',
    },
    filters: {
        title: 'Filters',
        search: 'Search by number or ID...',
        search_placeholder: 'Search lockers...',
        status: 'Status',
        all_status: 'All statuses',
        zone: 'Zone',
        all_zones: 'All zones',
        type: 'Type',
        all_types: 'All types',
        hotel: 'Hotel',
        all_hotels: 'All hotels',
        available_only: 'Only available',
        occupied_only: 'Only occupied',
        maintenance_only: 'Under maintenance',
        assignment: 'Assignment',
        with_assignment: 'With assignment',
        without_assignment: 'Without assignment',
    },
    actions: {
        create: 'New Locker',
        edit: 'Edit',
        delete: 'Delete',
        assign: 'Assign',
        release: 'Release',
        maintenance: 'Maintenance',
        activate: 'Activate',
        deactivate: 'Deactivate',
        view_details: 'View details',
        view_history: 'View history',
        bulk_assign: 'Assign multiple',
        bulk_release: 'Release multiple',
        export: 'Export lockers',
        import: 'Import lockers',
        block: 'Block',
        unblock: 'Unblock',
    },
    placeholders: {
        block_reason: 'e.g: Door broken, needs maintenance'
    },
    validation: {
        minLength: 'Minimum {{min}} characters',
        maxLength: 'Maximum {{max}} characters',
        positive: 'Must be a positive number'
    },
    help: {
        displayNumber: 'Visible locker number',
        hardwareId: 'Unique hardware identifier',
        notes: 'Additional observations about the locker'
    },
    sections: {
        basic_info: 'Basic Information',
        basic_info_subtitle: 'Main locker data',
        info: 'Additional information',
        create: 'Create Locker',
        create_subtitle: 'Enter the new locker details'
    },
    warnings: {
        occupied_edit: 'This locker is occupied. Some fields cannot be modified while in use.'
    },
    errors: {
        update: 'Error updating locker'
    },
    messages: {
        block_reason_required: 'You must indicate a reason to block the locker',
        block_success: 'Locker %{displayNumber} blocked successfully',
        block_error: 'Error blocking locker',
        unblock_success: 'Locker %{displayNumber} unblocked successfully',
        unblock_error: 'Error unblocking locker'
    },
    dialogs: {
        delete_title: 'Delete Locker',
        delete_message: 'Are you sure you want to delete locker {{displayNumber}}?',
        delete_warning: 'This action cannot be undone. The locker will be marked as inactive.',
        block_title: 'Block locker %{displayNumber}'
    },
    notifications: {
        updated: 'Locker {{displayNumber}} updated successfully'
    },
    helpers: {
        block_reason: 'Specify the reason why this locker is being blocked'
    }
};

export default lockers;
